'use client';

export { default } from './CardActionArea';
export { default as cardActionAreaClasses } from './cardActionAreaClasses';
export * from './cardActionAreaClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CardActionArea/index.js
// module id = 905
// module chunks = 25